/**
 * Labels canónicos (terminología JFT 2026-05-23 · SWAP):
 *
 *   TIPO DE ELECCIÓN (proceso · normatividad independiente):
 *     · REGIONAL    → Elecciones Regionales
 *     · MUNICIPAL   → Elecciones Municipales
 *
 *   NIVEL (granularidad de la lista):
 *     · REGIONAL    → 1 lista única (Gobernador+Vicegob + Consejeros regionales)
 *     · PROVINCIAL  → 1 lista por provincia (Alcalde Provincial + Regidores)
 *     · DISTRITAL   → 1 lista por distrito  (Alcalde Distrital  + Regidores)
 *
 * En BD el campo `tipo_eleccion` guarda los valores legacy ONPE; estos labels
 * normalizan para UI. Los query params HTTP son:
 *   · tipo_eleccion=REGIONAL|MUNICIPAL          (proceso · TIPO DE ELECCIÓN)
 *   · nivel=REGIONAL|PROVINCIAL|DISTRITAL       (granularidad · NIVEL)
 * El backend (routers/listas.py) expande ambos a Lista.tipo_eleccion.in_(...).
 */

const RAW_GOB = 'GOBERNADOR Y VICEGOBERNADOR';
const RAW_CONS = 'CONSEJERO REGIONAL';
const RAW_ALC_PROV = 'ALCALDE PROVINCIAL';
const RAW_ALC_DIST = 'ALCALDE DISTRITAL';

/** BD raw tipo_eleccion → label NIVEL (granularidad, 3 valores) */
export const NIVEL_LABEL: Record<string, string> = {
  [RAW_ALC_DIST]: 'DISTRITAL',
  [RAW_ALC_PROV]: 'PROVINCIAL',
  [RAW_GOB]:      'REGIONAL',
  [RAW_CONS]:     'REGIONAL',  // mismo grupo: forman la lista regional única
};

/** BD raw tipo_eleccion → label TIPO DE ELECCIÓN (proceso, 2 valores) */
export const TIPO_ELECCION_LABEL: Record<string, string> = {
  [RAW_ALC_DIST]: 'MUNICIPAL',
  [RAW_ALC_PROV]: 'MUNICIPAL',
  [RAW_GOB]:      'REGIONAL',
  [RAW_CONS]:     'REGIONAL',
};

/** Granularidad de lista (DISTRITAL/PROVINCIAL/REGIONAL) */
export function labelNivel(raw: string | null | undefined): string {
  if (!raw) return '—';
  return NIVEL_LABEL[raw] ?? raw;
}

/** Proceso electoral (REGIONAL/MUNICIPAL) */
export function labelTipoEleccion(raw: string | null | undefined): string {
  if (!raw) return '—';
  return TIPO_ELECCION_LABEL[raw] ?? raw;
}

/** Opciones para el filtro TIPO DE ELECCIÓN (proceso) */
export const TIPO_ELECCION_OPTIONS: Array<{ value: string; label: string }> = [
  { value: 'REGIONAL',  label: 'REGIONAL' },
  { value: 'MUNICIPAL', label: 'MUNICIPAL' },
];

/** Opciones para el filtro NIVEL (granularidad de lista) */
export const NIVEL_OPTIONS: Array<{ value: string; label: string }> = [
  { value: 'REGIONAL',   label: 'REGIONAL (Gob+Vice + Consejeros)' },
  { value: 'PROVINCIAL', label: 'PROVINCIAL (Alcalde Prov+Regidores)' },
  { value: 'DISTRITAL',  label: 'DISTRITAL (Alcalde Dist+Regidores)' },
];
